import './locales-selector.scss';
import { observer } from "mobx-react";
import { SingleValue } from "react-select";
import useTranslation from "../hooks/translation-hook";
import { FONT_COLOR, FONT_VARIANT } from '../../components/fonts/font-props';
import FontBody2 from '../../components/fonts/font-body2/font-body2';
import { SelectDropdownGrouped, IOption } from '../../components/inputs/select-dropdown-grouped/select-dropdown-grouped';
import Icon from '../../components/icons/icon/icon';
import IconHidden from '../../components/icons/icon-hidden/icon-hidden';
import IconTranslationIndicator from '../../components/icons/icon-translation-indicator/icon-translation-indicator';
import { Tooltip, TOOLTIP_VARIANTS } from '../../components/tooltip/tooltip';


const LocalesSelector = observer(() => {
    const { 
        localeList, 
        selectedLocale, 
        setSelectedLocale, 
        isLoading,
        hasMissingTranslations
    } = useTranslation();
    const selectedValue = () => {
        const locale = localeList.find(op => op.value === selectedLocale)
        if (locale) {
            return {
                value: locale.value,
                label: locale.label,
                isDisabled: false,
            };
        }        
    };

    const onChange = (op: SingleValue<IOption>) => {
        if (op) {
            setSelectedLocale(op.value as string);
        }
    }

    return (
        <div className="locale-select">
            <FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>Language</FontBody2>
            <SelectDropdownGrouped
                    options={[
                        {
                            category: <>Default language</>,
                            options: localeList.filter(locale => locale.default).map(locale => ({
                                value: locale.value,
                                label: <div className='locale-option'>
                                            {locale.label}
                                            {hasMissingTranslations([locale.value]) && 
                                                <Icon Component={IconTranslationIndicator} />}
                                        </div>,
                                isDisabled: false,
                            })),
                        },
                        {
                            category: <>Other languages</>,
                            options: localeList.filter(locale => !locale.default && locale.isEnabled).map(locale => ({
                                value: locale.value,
                                label: <div className='locale-option'>
                                            {locale.label}
                                            {hasMissingTranslations([locale.value]) && 
                                                <Icon Component={IconTranslationIndicator} />}
                                        </div>,
                                isDisabled: false,
                            })),
                        },
                        {
                            category: <>Hidden languages <Icon Component={IconHidden}/></>,
                            options: localeList.filter(locale => !locale.default && !locale.isEnabled).map(locale => ({
                                value: locale.value,
                                label: <div className='locale-option'>
                                            {locale.label}
                                            {hasMissingTranslations([locale.value]) && 
                                                <Icon Component={IconTranslationIndicator} />}
                                        </div>,
                                isDisabled: false,
                            })),
                        },
                    ]}
                    value={selectedValue()}
                    onChange={onChange}
                    isLoading={isLoading}
                />

            <div className='translation-indicator'>
                {hasMissingTranslations() && 
                    <Tooltip content={
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>Missing translations</FontBody2>
                    }
                    variant={TOOLTIP_VARIANTS.ERROR}
                    >
                        <Icon Component={IconTranslationIndicator} />
                    </Tooltip>
                }
            </div>
        </div>
    );
});

export default LocalesSelector;
